import { useAccountState } from 'contexts/account/account-context';
import { useParams } from 'react-router-dom';
import googleTagManager from 'utils/google-tag-manager';
import { OFD2Params } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/ofd-2-params.type';
import {
  InputSettingsEventMap,
  PartialInputSettingsFields,
} from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/input-settings-events.type';
import {
  OrderFeedEventMap,
  PartialOrderEventFields,
} from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/order-feed-events.type';
import {
  PartialTimelineEventFields,
  TimelineEvent,
  TimelineEventMap,
} from 'views/order-feed/features/my-supply-plan/types/google-tag-manager/timeline-events.type';

export const useGoogleTagManager = () => {
  const params = useParams<OFD2Params>();
  const {
    account: { company },
  } = useAccountState();

  const createTimelineEvent = <K extends keyof TimelineEventMap>(
    timelineEvent: K,
    partial: PartialTimelineEventFields<TimelineEvent>
  ): void => {
    const event = {
      ...partial,
      event: timelineEvent,
      siteId: params.globalSiteId,
      siteErpId: params.siteErpId,
      companyId: company!.companyId,
      companyErpId: company!.customerErpId,
      pageUrl: window.location.pathname,
    } as TimelineEventMap[K];

    googleTagManager.push(event);
  };

  const createOrderFeedEvent = <K extends keyof OrderFeedEventMap>(
    orderEvent: K,
    partial: PartialOrderEventFields<OrderFeedEventMap[K]>
  ): void => {
    const event = {
      ...partial,
      orderEvent,
      event: 'order_feed',
      siteId: params.globalSiteId,
      siteErpId: params.siteErpId,
      companyId: company!.companyId,
      companyErpId: company!.customerErpId,
      pageUrl: window.location.pathname,
    } as OrderFeedEventMap[K];

    googleTagManager.push(event);
  };

  const createInputSettingsEvent = <K extends keyof InputSettingsEventMap>(
    inputEvent: K,
    partial: PartialInputSettingsFields<InputSettingsEventMap[K]>
  ): void => {
    const event = {
      ...partial,
      inputSettingsEvent: inputEvent,
      event: 'input_settings',
      siteId: params.globalSiteId,
      siteErpId: params.siteErpId,
      companyId: company!.companyId,
      companyErpId: company!.customerErpId,
      pageUrl: window.location.pathname,
    } as InputSettingsEventMap[K];

    googleTagManager.push(event);
  };

  return {
    createOrderFeedEvent,
    createInputSettingsEvent,
    createTimelineEvent,
  };
};
